// ============================================
// moldClaw Checkout Success Page
// ============================================

/**
 * 🧑‍💻 SWE-4: Stripe Checkout 성공 후 리다이렉트 페이지
 */

import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function CheckoutSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(5);
  
  const sessionId = searchParams.get('session_id');
  
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/dashboard');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    
    return () => clearInterval(timer);
  }, [navigate]);
  
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Success Icon */}
        <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        
        {/* Title */}
        <h1 className="text-3xl font-bold text-white mb-4">
          결제 완료! 🎉
        </h1>
        
        {/* Message */}
        <p className="text-gray-400 mb-6">
          moldClaw 구독이 성공적으로 완료되었습니다.
          <br />
          라이선스 코드가 이메일로 발송되었습니다.
        </p>
        
        {/* Info Box */}
        <div className="bg-gray-800 rounded-lg p-4 mb-8 text-left">
          <h3 className="text-sm font-semibold text-gray-400 mb-2">다음 단계:</h3>
          <ol className="text-sm text-gray-300 space-y-2">
            <li className="flex items-start">
              <span className="w-5 h-5 bg-space-blue/20 text-space-blue-light rounded-full flex items-center justify-center text-xs mr-2 flex-shrink-0 mt-0.5">1</span>
              이메일에서 라이선스 코드를 확인하세요
            </li>
            <li className="flex items-start">
              <span className="w-5 h-5 bg-space-blue/20 text-space-blue-light rounded-full flex items-center justify-center text-xs mr-2 flex-shrink-0 mt-0.5">2</span>
              moldClaw 앱을 열고 라이선스 코드를 입력하세요
            </li>
            <li className="flex items-start">
              <span className="w-5 h-5 bg-space-blue/20 text-space-blue-light rounded-full flex items-center justify-center text-xs mr-2 flex-shrink-0 mt-0.5">3</span>
              모든 기능을 즐기세요!
            </li>
          </ol>
        </div>
        
        {/* Session ID (debug) */}
        {sessionId && (
          <p className="text-xs text-gray-600 mb-4">
            Session: {sessionId.slice(0, 20)}...
          </p>
        )}
        
        {/* Countdown & Button */}
        <p className="text-gray-500 mb-4">
          {countdown}초 후 대시보드로 이동합니다...
        </p>
        
        <button
          onClick={() => navigate('/dashboard')}
          className="px-6 py-3 bg-space-blue text-white rounded-lg font-semibold hover:bg-space-blue hover:brightness-110 transition-colors"
        >
          대시보드로 이동
        </button>
      </div>
    </div>
  );
}
